import React, { useState, useEffect,useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineSchedule,
  MdPersonOutline,
  MdGroups,
  MdPublic,
  MdGroup,
  MdCake,
  MdSend,
  MdPayments,
  MdPrivacyTip,
  MdAutorenew,
  MdArrowBack ,
  MdSchedule,    
  MdToday,      
  MdWarningAmber
} from "react-icons/md";


import { styles } from "../styles/SchedulePage.styles";
import { useAuth } from "../context/AuthContext";
import { getChats } from "../services/chat";
import Select from "react-select";
import { getTomadoresContact, getUtilizadoresContact } from "../services/Contacts";
import { getModelos, postAgendamento } from "../services/agendamento";



const typeOptions = [
  { value: "utilizador", label: "Utilizador", icon: MdPersonOutline },
  { value: "tomador", label: "Tomador", icon: MdPersonOutline },
  { value: "grupo", label: "Grupo", icon: MdGroups }
];

function SchedulePage({setActiveMenu}) {
  const [type, setType] = useState("utilizador");
  const [recipient, setRecipient] = useState("");
  const [message, setMessage] = useState("");
  const [conversations, setConversations] = useState([]);
  const [date, setDate] = useState("");
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);
  const { token, stampTomador } = useAuth(); 
  const [tomadores, setTomadores] = useState([]);
  const [utilizadores, setUtilizadores] = useState([]);
  const [modelo, setModelo] = useState("personalizado");
  const [modelos, setModelos] = useState([]);
  const [modeloObj, setModeloObj] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hora, setHora] = useState("09:30");
  const cleanRecipients = recipients.map(String);
  const [loadingTomadores, setLoadingTomadores] = useState(false);
  const [loadingUtilizadores, setLoadingUtilizadores] = useState(false);
  const [beforeTomadores, setBeforeTomadores] = useState(null);
  const [hasMoreTomadores, setHasMoreTomadores] = useState(true);
  const [loadingMoreTomadores, setLoadingMoreTomadores] = useState(false);
  const [beforeUtilizadores, setBeforeUtilizadores] = useState(null);
  const [hasMoreUtilizadores, setHasMoreUtilizadores] = useState(true);
  const [loadingMoreUtilizadores, setLoadingMoreUtilizadores] = useState(false);
  const didFetch = useRef(false);
  const textareaANTESRef = useRef(null);
  const textareaDIARef = useRef(null);
  const textareaATRASORef = useRef(null);
  const textareaMessageRef = useRef(null);
  const navigate = useNavigate();
  const normalizeMessage = (text = "") => {
    return text.replace(/####/g, "<NOME_EMPRESA>");
  };

  const extractPlaceholders = (text = "") => {
    const matches = text.match(/<([^>]+)>/g) || [];
    return [...new Set(matches)];
  };

  const renderMessagePreview = (text) => {
    if (!text) return [];

    const placeholderRegex = /<([^>]+)>/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = placeholderRegex.exec(text)) !== null) {
      // Texto antes do placeholder
      if (match.index > lastIndex) {
        parts.push({
          type: "text",
          value: text.substring(lastIndex, match.index)
        });
      }
      // O placeholder
      parts.push({
        type: "placeholder",
        value: match[0]
      });
      lastIndex = match.index + match[0].length;
    }

    // Texto restante
    if (lastIndex < text.length) {
      parts.push({
        type: "text",
        value: text.substring(lastIndex)
      });
    }

    return parts;
  };

  const removePlaceholder = (placeholder, fieldType = "ANTES") => {
    let currentValue;
    let setState;

    if (fieldType === "ANTES") {
      currentValue = mensagensCobranca.ANTES;
      setState = (text) => setMensagensCobranca(p => ({ ...p, ANTES: text }));
    } else if (fieldType === "DIA") {
      currentValue = mensagensCobranca.DIA;
      setState = (text) => setMensagensCobranca(p => ({ ...p, DIA: text }));
    } else if (fieldType === "ATRASO") {
      currentValue = mensagensCobranca.ATRASO;
      setState = (text) => setMensagensCobranca(p => ({ ...p, ATRASO: text }));
    }

    const newText = currentValue.replace(placeholder, "").replace(/\s+/g, " ").trim();
    setState(newText);
  };

  const insertPlaceholderAtCursor = (placeholder, fieldType = "ANTES") => {
    let textareaRef;
    let currentValue;
    let setState;

    if (fieldType === "ANTES") {
      textareaRef = textareaANTESRef;
      currentValue = mensagensCobranca.ANTES;
      setState = (text) => setMensagensCobranca(p => ({ ...p, ANTES: text }));
    } else if (fieldType === "DIA") {
      textareaRef = textareaDIARef;
      currentValue = mensagensCobranca.DIA;
      setState = (text) => setMensagensCobranca(p => ({ ...p, DIA: text }));
    } else if (fieldType === "ATRASO") {
      textareaRef = textareaATRASORef;
      currentValue = mensagensCobranca.ATRASO;
      setState = (text) => setMensagensCobranca(p => ({ ...p, ATRASO: text }));
    } else if (fieldType === "MESSAGE") {
      textareaRef = textareaMessageRef;
      currentValue = message;
      setState = setMessage;
    }

    if (!textareaRef?.current) return;

    const textarea = textareaRef.current;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText = currentValue.substring(0, start) + placeholder + currentValue.substring(end);
    setState(newText);

    // Colocar cursor após o placeholder
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + placeholder.length, start + placeholder.length);
    }, 0);
  };

  const handlePlaceholderDragStart = (e, placeholder) => {
    e.dataTransfer.effectAllowed = "copy";
    e.dataTransfer.setData("placeholder", placeholder);
  };

  const handleTextareaDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
    e.currentTarget.style.background = "#f0f4ff";
    e.currentTarget.style.borderColor = "#4338ca";
  };

  const handleTextareaDragLeave = (e) => {
    e.currentTarget.style.background = "";
    e.currentTarget.style.borderColor = "";
  };

  const handleTextareaDrop = (e, fieldType = "ANTES") => {
    e.preventDefault();
    e.currentTarget.style.background = "";
    e.currentTarget.style.borderColor = "";

    const placeholder = e.dataTransfer.getData("placeholder");
    if (placeholder) {
      const textarea = e.currentTarget;
      
      // Obter posição do rato relativa ao textarea
      const rect = textarea.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      let position = textarea.selectionStart;

      // Tentar usar caretPositionFromPoint se disponível (Firefox, Chrome)
      if (document.caretPositionFromPoint) {
        const caretPos = document.caretPositionFromPoint(e.clientX, e.clientY);
        if (caretPos && caretPos.offsetNode === textarea) {
          position = caretPos.offset;
        }
      } 
      // Fallback para WebKit (Safari, Chrome antigo)
      else if (document.caretRangeFromPoint) {
        const range = document.caretRangeFromPoint(e.clientX, e.clientY);
        if (range) {
          position = range.startOffset;
        }
      }

      let currentValue;
      let setState;

      if (fieldType === "ANTES") {
        currentValue = mensagensCobranca.ANTES;
        setState = (text) => setMensagensCobranca(p => ({ ...p, ANTES: text }));
      } else if (fieldType === "DIA") {
        currentValue = mensagensCobranca.DIA;
        setState = (text) => setMensagensCobranca(p => ({ ...p, DIA: text }));
      } else if (fieldType === "ATRASO") {
        currentValue = mensagensCobranca.ATRASO;
        setState = (text) => setMensagensCobranca(p => ({ ...p, ATRASO: text }));
      } else if (fieldType === "MESSAGE") {
        currentValue = message;
        setState = setMessage;
      }

      const newText = currentValue.substring(0, position) + placeholder + currentValue.substring(position);
      setState(newText);

      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(position + placeholder.length, position + placeholder.length);
      }, 0);
    }
  };
  const [mensagensCobranca, setMensagensCobranca] = useState({
    ANTES: "",
    DIA: "",
    ATRASO: ""
  });

  const [mensagemAniversario, setMensagemAniversario] = useState("");

  const [placeholders, setPlaceholders] = useState([]);

  const tipoLabel = (tipo) =>
    tipo === "C"
      ? "Cobranças"
      : tipo === "A"
      ? "Aniversários"
      : tipo === "R"
      ? "Recibos"
      : tipo === "MARKETING"
      ? "Aniversários"
      : tipo === "FINANCEIRO"
      ? "Cobranças"
      : tipo || "Outros";

  const faseLabel = (fase) =>
    fase === 1 ? "Antes"
    : fase === 2 ? "Dia"
    : fase === 3 ? "Atraso"
    : `Fase ${fase}`;

  const campaignOptions = modelos
    .filter((item) => Array.isArray(item.fases))
    .map((campaign) => {
      const firstModel =
        campaign.fases?.flatMap((f) => f.modelos || [])?.[0] || {};
      const derivedTipo =
        firstModel.tipo ||
        (campaign.tipo === "MARKETING" ? "A"
          : campaign.tipo === "FINANCEIRO" ? "C"
          : campaign.tipo);

      return {
        value: campaign.stamp || campaign.STAMP,
        label: campaign.nome || campaign.NOME || tipoLabel(derivedTipo),
        mensagem: "",
        tipo: campaign.tipo,
        TIPO: derivedTipo,
        fases: campaign.fases,
        icon:
          derivedTipo === "A"
            ? MdCake
            : derivedTipo === "C"
            ? MdPayments
            : MdSend,
      };
    });

  const plainModelOptions = modelos
    .filter((item) => !Array.isArray(item.fases))
    .map((m) => ({
      value: m.STAMP || m.stamp,
      label: m.TITULO || m.nome || `${tipoLabel(m.TIPO || m.tipo)} - ${faseLabel(m.FASE)}`,
      mensagem: m.MENSAGEM || m.mensagem,
      tipo: m.TIPO || m.tipo,
      TIPO: m.TIPO || m.tipo,
      fase: m.FASE,
      icon:
        (m.TIPO || m.tipo) === "A"
          ? MdCake
          : (m.TIPO || m.tipo) === "C"
          ? MdPayments
          : MdSend,
    }));

  const modeloOptions = [
    {
      value: "personalizado",
      label: "Personalizado",
      mensagem: "",
      icon: MdSend,
    },
    ...campaignOptions,
    ...plainModelOptions,
  ];

  const modeloOptionsFlat = modeloOptions;

  function parseMensagem(text) {
    const get = (tag) => {
      const match = text.match(new RegExp(`\\[${tag}\\]([\\s\\S]*?)(?=\\[|$)`));
      return match ? match[1].trim() : "";
    };

    return {
      ANTES: get("ANTES"),
      DIA: get("DIA"),
      ATRASO: get("ATRASO")
    };
  }


  const buildMensagensCobrancaFromFases = (fases = []) => {
    return fases.reduce(
      (acc, fase) => {
        const text = normalizeMessage(
          fase.modelos?.[0]?.mensagem || fase.modelos?.[0]?.MENSAGEM || ""
        );
        const faseNumber = Number(fase.fase || fase.FASE || fase.ordem);

        if (faseNumber === 1) acc.ANTES = text;
        else if (faseNumber === 2) acc.DIA = text;
        else if (faseNumber === 3) acc.ATRASO = text;

        return acc;
      },
      { ANTES: "", DIA: "", ATRASO: "" }
    );
  };

  const getAllFaseMessages = (fases = []) =>
    fases.flatMap((fase) =>
      (fase.modelos || []).map((modelo) =>
        normalizeMessage(modelo.mensagem || modelo.MENSAGEM || "")
      )
    );

  const formatModeloOption = ({ label, icon: Icon }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {Icon && <Icon size={18} color="#6b7280" />}
      <span>{label}</span>
    </div>
  );


  useEffect(() => {
    const fetchModelos = async () => {
      try {
        const data = await getModelos();
        setModelos(data?.agendamentos || data || []);
      } catch (err) {
        console.error("Erro ao buscar modelos:", err);
      }
    };

    fetchModelos();
  }, [token]);


  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes spinModern {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .spin-modern {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid rgba(0,0,0,0.1);
        border-top: 2px solid #ebeaea;
        animation: spinModern 0.8s linear infinite;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

 const fetchTomadores = async (reset = false, searchValue = "") => {
    try {
      if (reset) {
        setLoadingTomadores(true);

        // 👇 AQUI
        setTomadores([]);
        setBeforeTomadores(null);
        setHasMoreTomadores(true);
      } else {
        setLoadingMoreTomadores(true);
      }

      const data = await getTomadoresContact(
        20,
        reset ? null : beforeTomadores,
        searchValue
      );

      const newItems = data?.tomadores || [];

      setTomadores((prev) => {
        const merged = reset ? newItems : [...prev, ...newItems];

        const unique = Array.from(
          new Map(merged.map(item => [item.STAMP, item])).values()
        );

        return unique;
      });

      setHasMoreTomadores(data?.hasMore ?? false);

      if (newItems.length > 0) {
        setBeforeTomadores({
          nome: newItems[newItems.length - 1].NOME,
          stamp: newItems[newItems.length - 1].STAMP,
        });
      }

    } finally {
      setLoadingTomadores(false);
      setLoadingMoreTomadores(false);
    }
};

  const fetchUtilizadores = async (reset = false, searchValue = "") => {
      try {
        if (reset) {
          setLoadingUtilizadores(true);

          setUtilizadores([]);
          setBeforeUtilizadores(null);
          setHasMoreUtilizadores(true);
        } else {
          setLoadingMoreUtilizadores(true);
        }

        const data = await getUtilizadoresContact(
          20,
          reset ? null : beforeUtilizadores,
          searchValue
        );

        const newItems = data?.utilizadores || [];

        setUtilizadores((prev) => {
          const merged = reset ? newItems : [...prev, ...newItems];

          const unique = Array.from(
            new Map(merged.map(item => [item.STAMP, item])).values()
          ).sort((a, b) =>
            (a.NOME || "").localeCompare(b.NOME || "")
          );

          return unique;
        });

        setHasMoreUtilizadores(data?.hasMore ?? false);

        if (newItems.length > 0) {
          setBeforeUtilizadores({
            nome: newItems[newItems.length - 1].NOME,
            stamp: newItems[newItems.length - 1].STAMP,
          });
        }

      } finally {
        setLoadingUtilizadores(false);
        setLoadingMoreUtilizadores(false);
      }
  };


  const handleScrollTomadores = (e) => {
      const el = e.target;

      const bottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20;

      if (!bottom || !hasMoreTomadores || loadingMoreTomadores) return;

      fetchTomadores(false);
  };

  const handleScrollUtilizadores = (e) => {
      const el = e.target;

      const bottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 20;

      if (!bottom || !hasMoreUtilizadores || loadingMoreUtilizadores) return;

      fetchUtilizadores(false);
  };


  useEffect(() => {
  if (!token) return;
  if (didFetch.current) return;

  didFetch.current = true;

  fetchTomadores(true);
  fetchUtilizadores(true);
}, [token]);



  useEffect(() => {
    if (!token) return;


    const fetchConversations = async () => {
      try {
        const data = await getChats();
        setConversations(data.chats);


      } catch (err) {
        console.error("Erro ao buscar conversas:", err);
      }
    };

  

    fetchConversations();
  }, [token]);

  useEffect(() => {
      setRecipients([]);
      setRecipient("");
      setModelo("personalizado");
      setModeloObj(null);
      setMessage("");
      setError("");
  }, [type]);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSchedule = async () => {
   if (!type) return setError("Seleciona o tipo de envio");

    if (type === "grupo" || type === "tomador" || type === "utilizador") {
      if (!recipients || recipients.length === 0) {
        return setError("Seleciona pelo menos um destinatário");
      }
    }


    const isPersonalizado = modelo === "personalizado";
    const isModeloC = modeloObj?.TIPO === "C";

    if (isPersonalizado) {
      if (!message || message.trim() === "") {
        return setError("Escreve uma mensagem");
      }
    }

    if (isModeloC) {
      if (
        !mensagensCobranca.ANTES?.trim() &&
        !mensagensCobranca.DIA?.trim() &&
        !mensagensCobranca.ATRASO?.trim()
      ) {
        return setError("Preenche pelo menos uma mensagem de cobrança");
      }
    }

   

    if (type !== "tomador" && !date) {
      return setError("Seleciona data e hora de envio");
    }

    setLoading(true);

    let envio = null;

    if (type === "tomador") {
      const isPersonalizado = modelo === "personalizado";
      if (isPersonalizado) {
        if (date) {
          const d = new Date(date);
          envio = d.toISOString();
        }
      } else {
        const [h, m] = (hora || "09:30").split(":");
        envio = {
          HORA: `${h}:${m}`
        };
      }
    } else {
      if (date) {
        const d = new Date(date);
        envio = d.toISOString();
      }
    }
    
    const payload = {
      TIPO: type,
      CAMPANHA_STAMP: type === "tomador" && modelo !== "personalizado" ? modelo : null,
      CONTEUDO: message,
      ENVIAR_EM: envio,
      DESTINATARIOS: cleanRecipients,
      TIPO_MSG: "text",
    };

    if (modelo !== "personalizado") {
      if (modeloObj?.fases) {
        payload.MENSAGENS_CAMPANHA = modeloObj;
      } else {
        payload.MENSAGENS_CAMPANHA = mensagensCobranca;
      }
    } else {
      payload.MENSAGENS_COBRANCA = mensagensCobranca;
    }

    try {
      const response = await postAgendamento(payload);
      setLoading(false);

      if (!response || response.error || response.success === false) {
        console.error("Erro ao agendar:", response?.error || response);
        setError("Não foi possível criar o agendamento. Tente novamente.");
        return;
      }

      setDate("");
      setMessage("");
      setRecipients([]);
      setModelo("personalizado");
      navigate("/agendar");
    } catch (err) {
      setLoading(false);
      console.error("Erro ao agendar:", err);
      setError("Não foi possível criar o agendamento. Tente novamente.");
    }
  };

  const groupOptions = conversations
    .filter((c) => c.TIPO === "group")
    .map((c) => ({
      value: c.STAMP,
      label: c.NOME || c.STAMP,
      image: c.LOGO || null,
  }));

  const TMOptions = (Array.isArray(tomadores) ? tomadores : []).map((t) => ({
    value: t.STAMP,
    label: t.NOME || t.STAMP,
    image: t.FOTO || null
  }));


 const UtlOptions = (Array.isArray(utilizadores) ? utilizadores : []).map((u) => ({
    value: u.STAMP,
    label: u.NOME || u.STAMP,
    image: u.FOTO || null
  }));

 

 const formatOptionLabel = ({ label, image }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    
    {image ? (
      <img
        src={image}
        alt={label}
        style={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    ) : (
      <MdGroup size={18} color="#6b7280" />
    )}

    <span>{label}</span>
  </div>
);

  return (
    <div style={styles.page(isMobile)}>
      <div style={styles.headerRow(isMobile)}>
          <button
            onClick={() => navigate("/agendar")}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              marginRight: 10,
              display: "flex",
              alignItems: "center"
            }}
          >
            <MdArrowBack size={22} />
          </button>

          <div style={styles.iconBadge}>
            <MdOutlineSchedule size={22} />
          </div>

          <div>
            <h2 style={styles.title}>Agendar</h2>
            <p style={styles.subtitle}>
              Configura envios automáticos com um fluxo moderno e rápido.
            </p>
        </div>
      </div>

      <div style={styles.card(isMobile)}>
        <div style={styles.sectionHeader(isMobile)}>
          <div>
            <h3 style={styles.cardTitle}>Novo agendamento</h3>
            <p style={styles.cardDescription}>Escolhe o tipo de envio e define a mensagem antes de agendar.</p>
          </div>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Tipo de envio</label>
          <div style={styles.optionGroup(isMobile)}>
             {typeOptions.map((option) => {
              const active = type === option.value;
              const Icon = option.icon;
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    setType(option.value);
                    setRecipient("");
                    setRecipients([]);
                    setModelo("personalizado");
                    setModeloObj(null);
                    setMessage("");
                  }}
                  style={{
                    ...styles.optionButton,
                    ...(active ? styles.optionButtonActive : {}),
                  }}
                >
                  <Icon size={18} style={styles.optionButtonIcon} />
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>

        <div style={styles.formGroup}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Destinatário</label>
            {type === "grupo" ? (
              <Select
                isMulti
                options={groupOptions}
                value={groupOptions.filter((o) => recipients.includes(o.value))}
                onChange={(selected) =>
                  setRecipients(selected ? selected.map((s) => s.value) : [])
                }
                placeholder="Seleciona Grupos"
                formatOptionLabel={formatOptionLabel}
                isSearchable
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    borderColor: "#ccc",
                    minHeight: 42,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />          
            ) : (
              
            type === "tomador" ? (
            <Select
              isMulti
              isLoading={loadingTomadores}
              options={TMOptions}
              value={TMOptions.filter((o) =>
                recipients.some((r) => String(r) === String(o.value))
              )}
              onChange={(selected) =>
                setRecipients(selected ? selected.map((s) => s.value) : [])
              }
              placeholder="Seleciona Tomadores"
              formatOptionLabel={formatOptionLabel}
              isSearchable

              
              onInputChange={(inputValue, { action }) => {
                if (action === "input-change") {
                  fetchTomadores(true, inputValue);
                }
              }}

              onMenuScrollToBottom={() => {
                if (!loadingMoreTomadores && hasMoreTomadores) {
                  fetchTomadores(false);
                }
              }}

              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: 8,
                  borderColor: "#ccc",
                  minHeight: 42,
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />  
            ) : (
                type === "utilizador" ? (
                <Select
                  isMulti
                  isLoading={loadingUtilizadores}
                  options={UtlOptions}
                  value={UtlOptions.filter((o) =>
                    recipients.includes(o.value)
                  )}
                  onChange={(selected) =>
                    setRecipients(selected ? selected.map((s) => s.value) : [])
                  }
                  placeholder="Seleciona Utilizadores"
                  formatOptionLabel={formatOptionLabel}
                  isSearchable

                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      fetchUtilizadores(true, inputValue);
                    }
                  }}

                
                  onMenuScrollToBottom={() => {
                    if (!loadingMoreUtilizadores && hasMoreUtilizadores) {
                      fetchUtilizadores(false);
                    }
                  }}

                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: 8,
                      borderColor: "#ccc",
                      minHeight: 42,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />        
                ) : (
                    <input
                      value={recipient}
                      onChange={(e) => setRecipient(e.target.value)}
                      placeholder="ID, telefone ou email"
                      style={styles.input}
                    />
                  )
                )
            )}


            <span style={styles.helpText}>
              {type === "group"
                ? "Escolhe um grupo existente."
                : "Informe quem deve receber a mensagem."}
            </span>
          </div>

          {type === "tomador" && (
            <>
              <label style={styles.label}>Modelo de Mensagem</label>
              <Select
                options={modeloOptions}
                value={modeloOptionsFlat.find((o) => o.value === modelo) || null}
                onChange={(selected) => {
                  const selectedValue = selected?.value || "personalizado";
                  setModelo(selectedValue);

                  const obj = modelos.find(
                    (m) => String(m.STAMP || m.stamp) === String(selectedValue)
                  );

                  if (obj && Array.isArray(obj.fases)) {
                    const firstModel = obj.fases
                      .flatMap((fase) => fase.modelos || [])
                      .find(Boolean);
                    const derivedTipo =
                      firstModel?.tipo ||
                      (obj.tipo === "MARKETING" ? "A"
                        : obj.tipo === "FINANCEIRO" ? "C"
                        : obj.tipo);

                    const campaignMensagens = buildMensagensCobrancaFromFases(obj.fases);
                    const allMessages = getAllFaseMessages(obj.fases);

                    setModeloObj({
                      ...obj,
                      TIPO: derivedTipo,
                    });

                    setMensagensCobranca(campaignMensagens);
                    setMensagemAniversario(derivedTipo === "A" ? allMessages[0] || "" : "");
                    setMessage(derivedTipo === "A" ? allMessages[0] || "" : "");
                    setPlaceholders([
                      ...new Set(allMessages.flatMap((text) => extractPlaceholders(text))),
                    ]);
                    return;
                  }

                  const plainObj = obj || modelos.find(
                    (m) => String(m.STAMP || m.stamp) === String(selectedValue)
                  );
                  setModeloObj(plainObj || null);

                  if (selectedValue === "personalizado" || !plainObj) {
                    setMessage("");
                    setMensagemAniversario("");
                    setMensagensCobranca({ ANTES: "", DIA: "", ATRASO: "" });
                    setPlaceholders([]);
                    return;
                  }

                  const tipo = plainObj.TIPO || plainObj.tipo;

                  if (tipo === "C") {
                    const beforeMsg = normalizeMessage(plainObj.MENSAGEM || plainObj.mensagem || "");
                    setMensagensCobranca({ ANTES: beforeMsg, DIA: "", ATRASO: "" });
                    setMessage("");
                    setMensagemAniversario("");
                    setPlaceholders(extractPlaceholders(beforeMsg));
                    return;
                  }

                  if (tipo === "A") {
                    const aniversarioMsg =
                      normalizeMessage(plainObj.MENSAGEM || plainObj.mensagem || "") ||
                      "Parabéns <NOME>! 🎉\n\nDesejamos-lhe um excelente aniversário.";

                    setMensagemAniversario(aniversarioMsg);
                    setMessage(aniversarioMsg);
                    setMensagensCobranca({ ANTES: "", DIA: "", ATRASO: "" });
                    setPlaceholders([...new Set(extractPlaceholders(aniversarioMsg))]);
                    return;
                  }

                  const textoModelo = normalizeMessage(plainObj.MENSAGEM || plainObj.mensagem || "");
                  setMessage(textoModelo);
                  setMensagemAniversario("");
                  setMensagensCobranca({ ANTES: "", DIA: "", ATRASO: "" });
                  setPlaceholders(extractPlaceholders(textoModelo));
                }}
                placeholder="Selecione um modelo de mensagem"
                formatOptionLabel={formatModeloOption}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    borderColor: "#ccc",
                    minHeight: 42,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </>
          )}


        </div>
           

        <div style={styles.formGroup}>
          <label style={styles.label}>Mensagem</label>
            {modeloObj?.TIPO === "C" || modeloObj?.TIPO === "A" ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}> 
                    {placeholders.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 8,
                          marginBottom: 12
                        }}
                      >
                        {placeholders.map((p) => (
                          <button
                            key={p}
                            type="button"
                            draggable
                            onDragStart={(e) => handlePlaceholderDragStart(e, p)}
                            onClick={() => insertPlaceholderAtCursor(p, modeloObj?.TIPO === "A" ? "MESSAGE" : "ANTES")}
                            style={{
                              border: "1px solid #d1d5db",
                              background: "#eef2ff",
                              color: "rgb(31, 58, 112)",
                              borderRadius: 999,
                              padding: "6px 12px",
                              cursor: "grab",
                              fontSize: 12,
                              fontWeight: 600,
                              transition: "all 0.2s ease",
                              userSelect: "none"
                            }}
                            onMouseEnter={(e) => e.target.style.cursor = "grab"}
                          >
                            {p}
                          </button>
                        ))}
                      </div>
                    )}

                            
                    {modeloObj?.TIPO === "A" && (
                      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

                  
                        {message && renderMessagePreview(message).length > 0 && (
                          <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 6,
                            padding: 10,
                            background: "#f9fafb",
                            borderRadius: 6,
                            border: "1px solid #e5e7eb"
                          }}>
                            {renderMessagePreview(message).map((part, idx) =>
                              part.type === "placeholder" ? (
                                <button
                                  key={idx}
                                  type="button"
                                  onClick={() => {
                                    const newText = message
                                      .replace(part.value, "")
                                      .replace(/\s+/g, " ")
                                      .trim();
                                    setMessage(newText);
                                  }}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                    background: "rgb(31, 58, 112)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "4px 8px",
                                    fontSize: 12,
                                    cursor: "pointer"
                                  }}
                                >
                                  {part.value}
                                  <span style={{ marginLeft: 2 }}>✕</span>
                                </button>
                              ) : null
                            )}
                          </div>
                        )}


                        <textarea
                          ref={textareaMessageRef}
                          placeholder="Mensagem de aniversário..."
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          onDragOver={handleTextareaDragOver}
                          onDragLeave={handleTextareaDragLeave}
                          onDrop={(e) => handleTextareaDrop(e, "MESSAGE")}
                          style={styles.textarea}
                        />
                      </div>
                    )}

                 
                       
                  {modeloObj?.TIPO === "C" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                      {/* ANTES */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 500, color: "#6b7280" }}>
                          <MdSchedule size={18} />
                          ANTES
                        </div>


                        {mensagensCobranca.ANTES && renderMessagePreview(mensagensCobranca.ANTES).length > 0 && (
                          <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 6,
                            padding: 10,
                            background: "#f9fafb",
                            borderRadius: 6,
                            border: "1px solid #e5e7eb",
                            marginBottom: 8
                          }}>
                            {renderMessagePreview(mensagensCobranca.ANTES).map((part, idx) => 
                              part.type === "placeholder" ? (
                                <button
                                  key={idx}
                                  type="button"
                                  onClick={() => removePlaceholder(part.value, "ANTES")}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                    background: "rgb(31, 58, 112)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "4px 8px",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "rgb(15, 23, 42)"}
                                  onMouseLeave={(e) => e.target.style.background = "rgb(31, 58, 112)"}
                                >
                                  {part.value}
                                  <span style={{ marginLeft: 2, fontSize: 14 }}>✕</span>
                                </button>
                              ) : null
                            )}
                          </div>
                        )}

                        <textarea
                          ref={textareaANTESRef}
                          value={mensagensCobranca.ANTES}
                          onChange={(e) =>
                            setMensagensCobranca((p) => ({
                              ...p,
                              ANTES: e.target.value
                            }))
                          }
                          onDragOver={handleTextareaDragOver}
                          onDragLeave={handleTextareaDragLeave}
                          onDrop={(e) => handleTextareaDrop(e, "ANTES")}
                          style={styles.textarea}
                        />
                      </div>

                      {/* DIA */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 500, color: "#6b7280" }}>
                          <MdToday size={18} />
                          DIA
                        </div>

                        {mensagensCobranca.DIA && renderMessagePreview(mensagensCobranca.DIA).length > 0 && (
                          <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 6,
                            padding: 10,
                            background: "#f9fafb",
                            borderRadius: 6,
                            border: "1px solid #e5e7eb",
                            marginBottom: 8
                          }}>
                            {renderMessagePreview(mensagensCobranca.DIA).map((part, idx) => 
                              part.type === "placeholder" ? (
                                <button
                                  key={idx}
                                  type="button"
                                  onClick={() => removePlaceholder(part.value, "DIA")}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                    background: "rgb(31, 58, 112)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "4px 8px",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "rgb(15, 23, 42)"}
                                  onMouseLeave={(e) => e.target.style.background = "rgb(31, 58, 112)"}
                                >
                                  {part.value}
                                  <span style={{ marginLeft: 2, fontSize: 14 }}>✕</span>
                                </button>
                              ) : null
                            )}
                          </div>
                        )}

                        <textarea
                          ref={textareaDIARef}
                          value={mensagensCobranca.DIA}
                          onChange={(e) =>
                            setMensagensCobranca((p) => ({
                              ...p,
                              DIA: e.target.value
                            }))
                          }
                          onDragOver={handleTextareaDragOver}
                          onDragLeave={handleTextareaDragLeave}
                          onDrop={(e) => handleTextareaDrop(e, "DIA")}
                          style={styles.textarea}
                        />
                      </div>

                      {/* ATRASO */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, fontWeight: 500, color: "#6b7280" }}>
                          <MdWarningAmber size={18} />
                          ATRASO
                        </div>

                        {mensagensCobranca.ATRASO && renderMessagePreview(mensagensCobranca.ATRASO).length > 0 && (
                          <div style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 6,
                            padding: 10,
                            background: "#f9fafb",
                            borderRadius: 6,
                            border: "1px solid #e5e7eb",
                            marginBottom: 8
                          }}>
                            {renderMessagePreview(mensagensCobranca.ATRASO).map((part, idx) => 
                              part.type === "placeholder" ? (
                                <button
                                  key={idx}
                                  type="button"
                                  onClick={() => removePlaceholder(part.value, "ATRASO")}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 4,
                                    background: "rgb(31, 58, 112)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: 4,
                                    padding: "4px 8px",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseEnter={(e) => e.target.style.background = "rgb(15, 23, 42)"}
                                  onMouseLeave={(e) => e.target.style.background = "rgb(31, 58, 112)"}
                                >
                                  {part.value}
                                  <span style={{ marginLeft: 2, fontSize: 14 }}>✕</span>
                                </button>
                              ) : null
                            )}
                          </div>
                        )}

                        <textarea
                          ref={textareaATRASORef}
                          value={mensagensCobranca.ATRASO}
                          onChange={(e) =>
                            setMensagensCobranca((p) => ({
                              ...p,
                              ATRASO: e.target.value
                            }))
                          }
                          onDragOver={handleTextareaDragOver}
                          onDragLeave={handleTextareaDragLeave}
                          onDrop={(e) => handleTextareaDrop(e, "ATRASO")}
                          style={styles.textarea}
                        />
                      </div>
                    </div>
                  )}    

                </div>
          ) : (
              <textarea
                placeholder="Escreve a tua mensagem..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={styles.textarea}
              />
            )}
        </div>

      {(type !== "tomador" || (type === "tomador" && modelo === "personalizado")) && (     
        <div style={styles.formGroup}>
          <label style={styles.label}>Data e hora de envio</label>
          <input
            type="datetime-local"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={styles.input}
          />
        </div>
      )}

      {type === "tomador" && modelo !== "personalizado" && (
        <div style={styles.formGroup}>
          <label style={styles.label}>Hora de envio</label>
          <input
            type="time"
            value={hora}
            onChange={(e) => setHora(e.target.value)}
            style={styles.input}
          />
          <span style={styles.helpText}>
            Hora recomendada: 09:30
          </span>
        </div>
      )}



        {error && (
          <div style={{
            background: "#fee2e2",
            color: "#b91c1c",
            padding: "10px 12px",
            borderRadius: 8,
            fontSize: 13,
            marginBottom: 10,
            border: "1px solid #fecaca"
          }}>
            {error}
          </div>
        )}

       <button
        type="button"
        onClick={handleSchedule}
        disabled={loading}
        style={{
          ...styles.submitButton,
          opacity: loading ? 0.7 : 1,
          cursor: loading ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8
        }}
      >
       {loading ? (
          <>
            <div className="spin-modern" />
            A agendar...
          </>
        ) : (
          "Criar agendamento"
        )}
      </button>
      </div>
    </div>
  );
}

export default SchedulePage;

